import { ExportFilesList } from '@/features/export_files/List';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import styles from './exportFiles.module.scss';

const cx = classnames.bind(styles);

export const ExportFiles = () => {
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <p className={cx('description')}>{t('export_files_description')}</p>
      <ExportFilesList />
    </div>
  );
};
